/**
 * Created by wanghongxiang on 2017/6/27.
 */
import SnLayout from './Parser'

/* istanbul ignore next */
SnLayout.install = function (Vue) {
  Vue.component(SnLayout.name, SnLayout)
}

export default SnLayout



// WEBPACK FOOTER //
// ./src/components/common/portal/index.js